module.exports = __webpack_public_path__ + "static/img/200329.2b94155e.png";